import { Avatar, Link, Stack, Typography } from '@mui/material';
import { CustomMetaTitle, LinkReturnToMain } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import {
  ArrowBackBlue,
  DisabledVeteranNoAccess as DisabledVeteranNoAccessImg,
} from 'Images';

export const DisabledVeteranNoAccess = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.DisabledVeteran);
  const isDesktop = useIsDesktop();

  return (
    <Stack gap={'68px'}>
      <CustomMetaTitle title={dictionary.metaTitle} />
      <LinkReturnToMain />
      <Stack alignItems={'center'} gap={'24px'}>
        <Avatar
          alt={''}
          src={DisabledVeteranNoAccessImg}
          sx={{ width: '165px', height: '160px' }}
        />
        <Stack gap={'16px'} alignItems={'center'}>
          <Stack
            gap={'12px'}
            alignItems={'center'}
            maxWidth={isDesktop ? 'initial' : '285px'}
          >
            <Typography variant={'h2'} tabIndex={0} textAlign={'center'}>
              {dictionary.modal.title}
            </Typography>
            <Typography variant={'h4'} tabIndex={0}>
              {dictionary.modal.info1}
            </Typography>
          </Stack>
          <Stack
            direction={'row'}
            justifyContent={'center'}
            alignItems={'center'}
            gap={'5px'}
          >
            <Typography variant={'body3'} tabIndex={0}>
              {dictionary.modal.info2}
            </Typography>
            <Link href={dictionary.modal.info3url} underline={'hover'}>
              <Typography variant={'body3'} tabIndex={0}>
                {dictionary.modal.info3}
              </Typography>
            </Link>
            <Avatar
              alt={''}
              src={ArrowBackBlue}
              sx={{ width: '18px', height: '18px' }}
            />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
